module.exports = __webpack_public_path__ + "static/media/hw_mu_33.e384492d.flv";